// frontend/src/data/themeData.js
// Цветовые схемы и иконки для научных проектов

// ============================================
// ПАСТЕЛЬНЫЕ ЦВЕТА ДЛЯ НАУЧНЫХ ОБЛАСТЕЙ
// ============================================

export const FIELD_PASTEL_COLORS = {
  // Экономические науки - зеленые оттенки
  'Экономические науки': '#98C2A9',
  'Экономическая теория': '#95C0A7',
  'Макроэкономика': '#92BFA6',
  'Микроэкономика': '#8FBDA5',
  'Институциональная экономика': '#8CBBA5',
  'Поведенческая экономика': '#88B99B',
  'Экономика инноваций': '#85B79A',
  'Цифровая экономика': '#82B599',
  'Экономика данных': '#7FB399',
  'Экономика труда': '#7CB198',
  'Экономика образования': '#78AF8E',
  'Экономика здравоохранения': '#75AE8D',
  'Экономика развития': '#72AC8C',
  'Экологическая экономика': '#72AC8E',
  'Экономика знаний': '#72AC91',
  'Региональная экономика': '#72AC88', // 👈 заменен светло-фиолетовый

  // Финансы - синие оттенки
  'Финансы и кредит': '#94C3C7',
  'Корпоративные финансы': '#91C0C5',
  'Государственные финансы': '#8DBCC3',
  'Финансовые рынки': '#8AB8C2',
  'Банковское дело': '#87B4C0',
  'Страхование': '#83BABE',
  'Инвестиции': '#80B6BC',
  'Финансовый инжиниринг': '#7DB2BB',
  'Риск-менеджмент': '#79AEB9',
  'Финансовая устойчивость': '#76A9B7',
  'Финансовое планирование': '#73B1B5',
  'Бюджетирование': '#6FADB4',
  'Финансовый контроль': '#6CA8B2',
  'Управление активами': '#6CA6B2',
  'Портфельные инвестиции': '#6CA3B2',
  'Кредитный анализ': '#6CADB2',
  'Андеррайтинг': '#6CABB2',
  'Актуарные расчеты': '#6CA8B2',
  'Финансовые технологии (FinTech)': '#6CA6B2',
  'Криптовалюты и блокчейн': '#6CA3B2',
  'Краудфандинг': '#6CADB2',

  // IT - голубые/бирюзовые оттенки
  'Информационные технологии': '#92C3C9',
  'Бизнес-информатика': '#8EBFC7',
  'Прикладная информатика': '#8BBBC6',
  'Информационная безопасность': '#87B7C4',
  'Анализ данных': '#84B2C2',
  'Большие данные (Big Data)': '#81B9C1',
  'Искусственный интеллект': '#7DB5BF',
  'Машинное обучение': '#7AB1BD',
  'Цифровая трансформация': '#76ACBC',
  'Интернет вещей (IoT)': '#73A8BA',
  'Облачные вычисления': '#6FB0B8',
  'Кибербезопасность': '#6CABB7',
  'Разработка программного обеспечения': '#69A7B5',
  'Базы данных': '#69A4B5',
  'Информационные системы': '#69A1B5',
  'Компьютерное зрение': '#69ACB5',
  'Обработка естественного языка': '#69A9B5',

  // Учет и аудит - оранжевые оттенки
  'Учет и аудит': '#CDAA8E',
  'Бухгалтерский учет': '#CCAA8A',
  'Управленческий учет': '#CAAA87',
  'Финансовый учет': '#C8AA83',
  'МСФО': '#C7AA80',
  'Аудит': '#C59D7C',
  'Налоговый учет': '#C49D78',
  'Налоговый консалтинг': '#C29D75',
  'Финансовый контроль': '#C19E71',
  'Экономическая экспертиза': '#BF9E6E',

  // Менеджмент - фиолетовые оттенки
  'Менеджмент': '#A79EBC',
  'Стратегический менеджмент': '#A69BBA',
  'Управление проектами': '#A498B8',
  'Инновационный менеджмент': '#A395B6',
  'Корпоративное управление': '#A192B4',
  'Управление персоналом': '#998FB2',
  'Маркетинг': '#988CB0',
  'Бренд-менеджмент': '#9789AE',
  'Логистика': '#9586AC',
  'Управление цепочками поставок': '#9483AA',
  'Бизнес-аналитика': '#8C80A8',
  'Производственный менеджмент': '#8A7DA6',
  'Антикризисное управление': '#897AA4',
  'Управление качеством': '#8B7AA4',
  'Кросс-культурный менеджмент': '#8C7AA4',
  'Управление изменениями': '#867AA4',

  // Маркетинг - оранжево-розовые
  'Маркетинг': '#CB9095',
  'Маркетинговые исследования': '#CA8C8F',
  'Поведение потребителей': '#C88989',
  'Брендинг': '#C68785',
  'Маркетинговые коммуникации': '#C58682',
  'Цифровой маркетинг': '#C37E84',
  'Маркетинг в социальных сетях': '#C27B7E',
  'Маркетинговый анализ': '#C07778',
  'Стратегический маркетинг': '#BE7574',
  'Маркетинг услуг': '#BD7570',
  'Международный маркетинг': '#BB6D73', // 👈 заменен приглушенный красный

  // Международные отношения - красные/розовые оттенки
  'Международные отношения': '#C497A7',
  'Мировая экономика': '#C293A2',
  'Международные финансы': '#C1909E',
  'Международный бизнес': '#BF8D99',
  'Внешнеэкономическая деятельность': '#BD8A95',
  'Международные валютно-кредитные отношения': '#BB8699',
  'Глобальные финансовые рынки': '#B98394',
  'Международные инвестиции': '#B78090',
  'Международный маркетинг': '#B57D8B',
  'Евразийская интеграция': '#B47986',
  'Экономика зарубежных стран': '#B2768B',
  'Международные экономические организации': '#B07386',
  'Международное налогообложение': '#AE6F81',

  // Право - коричневые/песочные оттенки
  'Юридические науки': '#C0B29B',
  'Финансовое право': '#BEB198',
  'Налоговое право': '#BCB095',
  'Предпринимательское право': '#BAAF92',
  'Банковское право': '#B8AE8F',
  'Гражданское право': '#B6A68C',
  'Правовое регулирование цифровой экономики': '#B4A588',
  'Правовые основы финансового контроля': '#B2A485',
  'Международное финансовое право': '#B0A382',
  'Правовое обеспечение экономической безопасности': '#AEA37F',
  'Правовое регулирование рынка ценных бумаг': '#AC9A7C',
  'Административное право': '#AA9979',
  'Конституционное право': '#A89976',
  'Трудовое право': '#A89A76',

  // Социология - розовые оттенки
  'Социологические науки': '#C299AA',
  'Экономическая социология': '#C096A6',
  'Социология управления': '#BE93A2',
  'Политический анализ': '#BC8F9E',
  'Социальные исследования': '#BA8C99',
  'Поведение потребителей': '#B8899D',
  'Общественное мнение': '#B68699',
  'Политические риски': '#B48394',
  'Социальное прогнозирование': '#B37F90',
  'Электоральные исследования': '#B17C8B',
  'Социология финансового поведения': '#AF7990',
  'Социология образования': '#AD768B',
  'Социология труда': '#AB7386',

  // Госуправление - индиго/сиреневые
  'Государственное управление': '#9E9EBD',
  'Муниципальное управление': '#9B9ABB',
  'Бюджетный процесс': '#9997B9',
  'Государственные закупки': '#9794B7',
  'Государственная служба': '#9691B5',
  'Стратегическое планирование': '#8E8FB3',
  'Управление государственными программами': '#8C8BB1',
  'Государственно-частное партнерство': '#8A88AF',
  'Региональное развитие': '#8885AD',
  'Государственная политика': '#8782AB',
  'Административная реформа': '#7F80A9',

  // Налоги - желтые оттенки
  'Налоги и налогообложение': '#CFAE8C',
  'Налоговое администрирование': '#CDAE88',
  'Налоговый контроль': '#CCAF85',
  'Налоговое планирование': '#CAAF81',
  'Налоговый консалтинг': '#C9AF7E',
  'Международное налогообложение': '#C7A27A',
  'Трансфертное ценообразование': '#C6A276',
  'Налоговая нагрузка': '#C4A373',
  'Налоговые льготы': '#C3A36F',
  'Специальные налоговые режимы': '#C1A46C',
  'Налоговая политика': '#C09568',

  // Экономическая безопасность - зелено-голубые оттенки (👈 ПОЛНОСТЬЮ ЗАМЕНЕНО)
  'Экономическая безопасность': '#9BC0AC',
  'Управление рисками': '#98BEAB',
  'Финансовый мониторинг': '#95BCAA',
  'Противодействие легализации доходов': '#92BAA8',
  'Корпоративная безопасность': '#8EB8A7',
  'Антикризисное управление': '#8BB69F',
  'Финансовая разведка': '#88B49E',
  'Комплаенс-контроль': '#85B29D',
  'Кибербезопасность в финансах': '#82B09C',
  'Оценка рисков': '#7FAE9B',

  // Математика - фиолетовые
  'Математические методы': '#9CA1BF',
  'Математическое моделирование': '#999DBD',
  'Имитационное моделирование': '#9699BB',
  'Оптимизационные модели': '#9394B9',
  'Теория игр': '#8F90B7',
  'Динамическое программирование': '#8C93B5',
  'Стохастические процессы': '#898EB3',
  'Монте-Карло симуляции': '#868AB1',
  'Байесовские методы': '#8385AF',
  'Эконометрика': '#8081AD',
  'Статистика': '#7D84AB',
  'Анализ временных рядов': '#7A7FA9',
  'Панельные данные': '#777BA7',

  // Психология - лавандовые
  'Психологические науки': '#AF9CBE',
  'Психология управления': '#AE99BC',
  'Организационная психология': '#AD96BA',
  'Психология труда': '#AC93B8',
  'Социальная психология': '#AB90B6',
  'Психология личности': '#A38DB4',
  'Психология общения': '#A28AB2',
  'Психология конфликта': '#A187B0',
  'Психология принятия решений': '#A084AE',
  'Когнитивная психология': '#9F81AC',

  // Педагогика - мятные
  'Педагогические науки': '#9AC1B4',
  'Педагогика высшей школы': '#97BFB3',
  'Методика преподавания': '#94BDB2',
  'Образовательные технологии': '#90BBB2',
  'Цифровое образование': '#8DB9B1',
  'Управление образованием': '#8AB7A8',
  'Качество образования': '#87B5A8',
  'Непрерывное образование': '#84B3A7',
  'Дистанционное обучение': '#81B1A7',

  // Лингвистика - салатовые
  'Лингвистика': '#AEC09B',
  'Межкультурная коммуникация': '#AABE98',
  'Переводоведение': '#A6BC95',
  'Профессиональная коммуникация': '#A2BA92',
  'Деловой иностранный язык': '#9DB88F',
  'Терминоведение': '#A1B68C',
  'Дискурс-анализ': '#9DB488',

  // История - шампань
  'Исторические науки': '#CDB68E',
  'История экономики': '#CBB68A',
  'История финансов': '#CAB687',
  'История экономической мысли': '#C8B683',
  'История предпринимательства': '#C7B780',
  'История государства и права': '#C5AA7C',
  'История России': '#C4AA79',
  'Всеобщая история': '#C2AB75',

  // Философия - кремовые
  'Философские науки': '#C3AB98',
  'Философия экономики': '#C1AA94',
  'Философия науки': '#C0A991',
  'Социальная философия': '#BEA88E',
  'Этика бизнеса': '#BCA88B',
  'Философская антропология': '#BA9E87',
  'Методология науки': '#B89D84', // 👈 заменен светло-лиловый
};

// ============================================
// ЯРКИЕ ЦВЕТА ДЛЯ СТАТУСОВ (дополнительно)
// ============================================

export const STATUS_COLORS = {
  'active': '#4caf50',
  'recruiting': '#2196f3',
  'draft': '#9e9e9e',
  'completed': '#9c27b0',
  'on_hold': '#ff9800',
  'archived': '#607d8b',
};

// ============================================
// ИКОНКИ ДЛЯ ТИПОВ ПРОЕКТОВ
// ============================================

export const PROJECT_TYPE_ICONS = {
  'research_paper': '📄',
  'dissertation': '📚',
  'grant': '💰',
  'conference': '🎤',
  'book': '📖',
  'creative': '🎨',
  'other': '🔬',
};

// ============================================
// ИКОНКИ ДЛЯ КОМПЕТЕНЦИЙ
// ============================================

export const COMPETENCY_ICONS = {
  // Языки программирования
  'Python': '🐍',
  'R': '📊',
  'SQL': '🗄️',
  'JavaScript': '💛',
  'Java': '☕',
  'C++': '⚙️',
  'C#': '🎯',
  'PHP': '🐘',
  'Ruby': '💎',
  'Go': '🔵',
  'Rust': '⚙️',
  'Swift': '🐦',
  'Kotlin': '🟣',
  'MATLAB': '📐',
  'Julia': '🔴',
  'SAS': '📈',
  'Stata': '📉',
  'SPSS': '📊',

  // Инструменты
  'Excel': '📈',
  'Excel (продвинутый уровень)': '📊',
  'VBA': '📊',
  'Tableau': '📊',
  'Power BI': '📊',
  'QlikView': '📊',
  '1С:Предприятие': '📦',
  'SAP': '🏢',
  'Oracle': '🗄️',
  'Bloomberg': '💹',
  'Reuters Eikon': '📈',
  'Git': '📂',
  'Docker': '🐳',
  'Kubernetes': '⚓',

  // Аналитика
  'Статистический анализ': '📉',
  'Регрессионный анализ': '📈',
  'Кластерный анализ': '🔬',
  'Факторный анализ': '🧮',
  'Анализ временных рядов': '⏱️',
  'Прогнозирование': '🔮',
  'Сценарный анализ': '🎲',
  'Финансовый анализ': '💰',
  'Инвестиционный анализ': '📊',
  'Риск-анализ': '⚠️',
  'Анализ безубыточности': '⚖️',
  'Анализ денежных потоков': '💵',
  'Бюджетный анализ': '📒',
  'Налоговый анализ': '📑',
  'Маркетинговый анализ': '📢',
  'Анализ рынка': '🏪',
  'Конкурентный анализ': '🥊',
  'SWOT-анализ': '📊',
  'PEST-анализ': '🌍',

  // Data Science
  'Анализ данных': '🔍',
  'Большие данные (Big Data)': '💾',
  'Data Mining': '⛏️',
  'Машинное обучение': '🤖',
  'Глубокое обучение': '🧠',
  'Нейронные сети': '🕸️',
  'Компьютерное зрение': '👁️',
  'Обработка естественного языка': '🗣️',
  'Текстовая аналитика': '📝',
  'Байесовские методы': '🎲',
  'Монте-Карло симуляции': '🎰',

  // Языки
  'Английский': '🇬🇧',
  'Английский (чтение литературы)': '📖',
  'Английский (научное письмо)': '✍️',
  'Английский (устная коммуникация)': '🗣️',
  'Английский (свободное владение)': '🌍',
  'Немецкий': '🇩🇪',
  'Французский': '🇫🇷',
  'Испанский': '🇪🇸',
  'Итальянский': '🇮🇹',
  'Китайский': '🇨🇳',
  'Японский': '🇯🇵',
  'Корейский': '🇰🇷',
  'Арабский': '🇸🇦',
  'Турецкий': '🇹🇷',
  'Польский': '🇵🇱',
  'Чешский': '🇨🇿',

  // Финансовые
  'Финансовый менеджмент': '💼',
  'Корпоративные финансы': '🏢',
  'Управление инвестициями': '📈',
  'Оценка бизнеса': '🏷️',
  'Оценка инвестиционных проектов': '📊',
  'Финансовое планирование': '📅',
  'Бюджетирование': '📒',
  'Управление рисками': '🛡️',
  'Хеджирование': '🔒',
  'Портфельные инвестиции': '📊',
  'Управление активами': '💎',
  'Банковское дело': '🏦',
  'Кредитный анализ': '💳',
  'Андеррайтинг': '📝',
  'Страхование': '🛡️',
  'Актуарные расчеты': '🧮',
  'Финансовые рынки': '📉',
  'Трейдинг': '📊',
  'Технический анализ': '📈',
  'Фундаментальный анализ': '🔍',
  'Деривативы': '📃',
  'Финансовые технологии (FinTech)': '💳',
  'Криптовалюты и блокчейн': '₿',
  'Краудфандинг': '🤝',

  // Экономические
  'Макроэкономический анализ': '🌍',
  'Микроэкономический анализ': '🏪',
  'Экономика фирмы': '🏢',
  'Экономика отраслевых рынков': '🏭',
  'Экономика общественного сектора': '🏛️',
  'Пространственная экономика': '🗺️',
  'Международная экономика': '🌐',
  'Институциональная экономика': '🏛️',
  'Поведенческая экономика': '🧠',
  'Цифровая экономика': '💻',

  // Менеджмент
  'Стратегический менеджмент': '🎯',
  'Управление проектами': '📋',
  'Инновационный менеджмент': '💡',
  'Корпоративное управление': '🏛️',
  'Управление персоналом': '👥',
  'Маркетинг': '📢',
  'Бренд-менеджмент': '⭐',
  'Логистика': '🚚',
  'Управление цепочками поставок': '⛓️',
  'Бизнес-аналитика': '📊',

  // Софт-скиллы
  'Научное письмо': '📝',
  'Академическое письмо': '📚',
  'Публичные выступления': '🎤',
  'Презентационные навыки': '📽️',
  'Работа в команде': '👥',
  'Тайм-менеджмент': '⏰',
  'Наставничество': '👨‍🏫',
  'Менторство': '🎓',
  'Рецензирование': '🔍',
  'Грантрайтинг': '💰',
  'Организация конференций': '🎪',
  'Модерация сессий': '🎙️',
  'Научное редактирование': '📝',
  'Корректура': '✅',

  // Методологии
  'Эконометрика': '📐',
  'Математическое моделирование': '📏',
  'Имитационное моделирование': '🔄',
  'Оптимизационные модели': '⚡',
  'Теория игр': '🎲',
  'Стохастические процессы': '🌊',
  'Качественные исследования': '🔍',
  'Экспертные оценки': '👥',
  'Кейс-стади': '📁',
  'Сравнительный анализ': '⚖️',
  'Контент-анализ': '📄',
  'Дискурс-анализ': '💬',
  'Сетевой анализ': '🕸️',
  'Мета-анализ': '📊',
  'Библиометрический анализ': '📚',
  'Наукометрия': '📊',
};

// ============================================
// ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ
// ============================================

/**
 * Палитры научных областей.
 *
 * main  — основной насыщенный оттенок, используется карточками и акцентами;
 * light — мягкий фон;
 * soft  — почти нейтральный фон;
 * dark  — текст/контрастный акцент.
 */
const hexToRgb = (hex) => {
  const value = hex.replace('#', '');
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  };
};

const mixHex = (hexA, hexB, amount) => {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  const mix = (x, y) => Math.round(x + (y - x) * amount);
  return `#${[mix(a.r, b.r), mix(a.g, b.g), mix(a.b, b.b)]
    .map((v) => v.toString(16).padStart(2, '0'))
    .join('')}`;
};

export const getFieldPalette = (field) => {
  const main = getFieldColor(field);
  return {
    main,
    light: mixHex(main, '#FFFFFF', 0.70),
    soft: mixHex(main, '#FFFFFF', 0.88),
    dark: mixHex(main, '#173F42', 0.38),
  };
};

/**
 * Получить цвет для научной области
 * @param {string} field - название научной области
 * @returns {string} цвет в HEX
 */
export const getFieldColor = (field) => {
  if (!field) return '#DCE9E9'; // мягкий серо-голубой для пустых полей

  // Сначала ищем точное совпадение
  if (FIELD_PASTEL_COLORS[field]) {
    return FIELD_PASTEL_COLORS[field];
  }

  // Ищем частичное совпадение
  for (const [key, color] of Object.entries(FIELD_PASTEL_COLORS)) {
    if (field.includes(key) || key.includes(field)) {
      return color;
    }
  }

  // Если ничего не нашли, возвращаем цвет на основе первой буквы
  const firstLetter = field.charAt(0).toLowerCase();
  const defaultColors = {
    'а': '#D8E8E6', 'б': '#DCE9E0', 'в': '#DCE8ED', 'г': '#E9E3CF',
    'д': '#D8E7EA', 'е': '#E9DEDC', 'ж': '#E3E1EC', 'з': '#E6DEEA',
    'и': '#D9E8E5', 'к': '#ECE5D4', 'л': '#E0E9D7', 'м': '#E4DFEA',
    'н': '#DCE9EF', 'о': '#ECE2D5', 'п': '#DCE9E0', 'р': '#EADDDD',
    'с': '#D8E9EA', 'т': '#E8E9D8', 'у': '#E4E0DB', 'ф': '#EADDE2',
    'х': '#E3DCE8', 'ц': '#D9E7EA', 'ч': '#D8E8E4', 'ш': '#DED9E8',
    'э': '#E2DEDA', 'ю': '#DCE4E8', 'я': '#D9E8DD',
  };

  return defaultColors[firstLetter] || '#e9ecef';
};

/**
 * Получить иконку для компетенции
 * @param {string} competency - название компетенции
 * @returns {string} иконка-эмодзи
 */
export const getCompetencyIcon = (competency) => {
  if (!competency) return '•';

  // Точное совпадение
  if (COMPETENCY_ICONS[competency]) {
    return COMPETENCY_ICONS[competency];
  }

  // Частичное совпадение
  for (const [key, icon] of Object.entries(COMPETENCY_ICONS)) {
    if (competency.includes(key)) {
      return icon;
    }
  }

  return '•';
};

/**
 * Получить иконку для типа проекта
 * @param {string} type - тип проекта
 * @returns {string} иконка-эмодзи
 */
export const getProjectTypeIcon = (type) => {
  return PROJECT_TYPE_ICONS[type] || '🔬';
};

/**
 * Получить цвет для статуса
 * @param {string} status - статус проекта
 * @returns {string} цвет в HEX
 */
export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || '#9e9e9e';
};